import { Component, OnInit, Inject } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { take } from 'rxjs/operators';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ContagemInventarioService } from 'src/app/services/contagem-inventario/contagem-inventario.service';
import { DatePipe } from '@angular/common';
import { InventarioRelatorioComponent } from '../inventario-relatorio/inventario-relatorio.component';
import { environment } from 'src/environments/environment';
import { StorageService } from 'src/app/services/storage/storage.service';


@Component({
  selector: 'app-contagem-inventario',
  templateUrl: './contagem-inventario.component.html',
  styleUrls: ['./contagem-inventario.component.scss']
})
export class ContagemInventarioComponent implements OnInit {
  public isLoading = false;
  public inventarioId: number;
  public inventarioContagemId: number;
  public agente: string = '-';
  public codIATA: string = '-';
  public numeroContagem: string = '-';
  public dataCriacaoContagem: string = '-';
  public criadoPorContagem: string = '-';
  public excelUrl: any;
  public pdfUrl: any;  
  public perfilAcessoTipoId;

  constructor(
    private dialogRef: MatDialogRef<InventarioRelatorioComponent>,
    private contagemInventarioService: ContagemInventarioService,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.inventarioId = data.item.inventarioId;
    this.inventarioContagemId= data.item.inventarioContagemId;
    this.agente = data.item.agente;
    this.codIATA = data.item.codIATA;
    this.numeroContagem = data.item.numeroContagem;
    this.dataCriacaoContagem = this.transformDate(data.item.dataCriacaoContagem);
    this.criadoPorContagem = data.item.criadoPorContagem;
    this.perfilAcessoTipoId = StorageService.getPerfilUsuario().perfilacessotipo;
   }

  ngOnInit() {
    this.initInventario();
    this.updateUrlExcel();
    this.updateUrlPDF();
  }

  public initInventario(){
    const obj = {
      numero: this.inventarioId,
      paginaAtual: 0,
      itensPorPagina: 1,
    };

    this.contagemInventarioService
      .getAllInventario(obj)
      .pipe(take(1))
      .subscribe(
        (response: HttpResponse<any[]>) => {
          this.isLoading = false;
          if (response.body.length > 0) {
            this.agente = response.body[0].agente;
            this.codIATA= response.body[0].codIATA;
            this.numeroContagem = response.body[0].contagem;
            this.dataCriacaoContagem = this.transformDate(response.body[0].dtCriacao)
            this.criadoPorContagem = response.body[0].usuarioCriacao
          }
        },
        () => {
          this.isLoading = false;
          this.openSnackBar(
            "Erro ao carregar listagem Inventario!",
            "OK",
            5000,
            "danger-snackbar"
          );
        }
      );    
  }

  public fechar() {
    this.dialogRef.close();
  }

  private openSnackBar(
    message: string,
    action: string,
    duration: number,
    panelClass?: string
  ): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }  

  transformDate(value: string) {
    var datePipe = new DatePipe("en-BR"); 
     value = datePipe.transform(value, 'dd/MM/yyyy hh:mm');
     return value;
 }

 updateUrlExcel() {
  this.excelUrl = `${environment.api}ContagemInventario/ExportarExcel?
  ${this.inventarioContagemId ? `&numero=${this.inventarioContagemId}` : '&numero=-1'}
  ${'&PaginaAtual=1&ItensPorPagina=999999'}`
 }

 updateUrlPDF() {
 this.pdfUrl = `${environment.api}ContagemInventario/ExportarPDF?
 ${this.inventarioContagemId ? `&numero=${this.inventarioContagemId}` : '&numero=-1'}
 ${'&PaginaAtual=1&ItensPorPagina=999999'}`
}
}
